export const MIN_SCENE_WIDTH = 5; // in px
